"use strict";

angular.module("internal.exams").controller("InternalExamTypes", [
    "$scope",
    "EXType",
    function($scope, EXType) {
        $scope.loading = true;

        EXType.get().then(function(Types) {
            $scope.Types = Types.records;
            $scope.loading = false;
        });

        $scope.columns = [
            {
                label: "Name",
                field: "name",
                link: {
                    state: "internal.exams.administrative.type",
                    params: [
                        {
                            name: "examTypeID",
                            field: "id"
                        }
                    ]
                }
            },
            {
                label: "Exam Session Count",
                field: "sessionCount"
            },
            {
                label: "Last Modified",
                field: "modifiedOnUtc",
                type: "datetime"
            },
            {
                label: "Modified By",
                field: "modifiedByFullName"
            }
        ];
    }
]);
